// 261010 Epic 2 / P3c — DẢI hồ sơ phong cách trên đầu bước 2 Tài sản (mẫu `styleStrip`): trạng thái · bản · chip · "Xem / Ẩn hồ sơ phong cách" · "AI đề xuất" khi truyện chưa có hồ sơ.
// Chữ do `stripOf` (styleProfilePolicy.ts, có test) quyết; component chỉ vẽ.
import React from 'react';
import { Spin } from 'antd';
import { styleCardTitleOf, type StyleAction, type StyleStrip } from './styleProfilePolicy';

interface Props {
  strip: StyleStrip;
  open: boolean;
  /** Nút "AI đề xuất" ở dải (chỉ hiện khi truyện chưa có hồ sơ; có hồ sơ rồi thì "AI đề xuất lại" nằm ở đầu panel). */
  generate?: StyleAction;
  onToggle: () => void;
  onGenerate: () => void;
}

const WorkflowStyleStrip: React.FC<Props> = ({ strip, open, generate, onToggle, onGenerate }) => (
  <div className="wf-sty-strip" role="status" data-testid="wf-sty-strip" data-state={strip.state} aria-busy={strip.state === 'DRAFTING' || strip.state === 'LOADING'}>
    {strip.state === 'LOADING' || strip.state === 'DRAFTING' ? <Spin size="small" /> : null}
    <span className="t" title={strip.text} data-testid="wf-sty-title">{styleCardTitleOf(strip)}</span> {/* UI-assets: tiêu đề cố định; câu dài ở tooltip */}
    {strip.chip ? <span className={`wf-chip ${strip.chip.tone}`}>{strip.chip.label}</span> : null}
    {strip.drift ? <span className="drift">· {strip.drift}</span> : null}
    <span className="sp" />
    {strip.state === 'NONE' && generate?.visible ? (
      <button type="button" className="wf-btn primary" disabled={!generate.enabled} title={generate.reason} onClick={onGenerate} data-action={generate.key}>{generate.label}</button>
    ) : null}
    {strip.state !== 'LOADING' ? (
      <button type="button" className="wf-btn" onClick={onToggle} aria-expanded={open} data-action="STYLE_TOGGLE">{open ? 'Ẩn hồ sơ' : 'Xem hồ sơ phong cách'}</button>
    ) : null}
  </div>
);

export default WorkflowStyleStrip;
